<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Buscar etapa</v-card-title>
        <v-container>
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">Modalidade</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2">Nível</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 3" step="3">Fase</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="4">Etapa</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-radio-group v-if="modalidades.length" v-model="choices.modalidade">
                  <v-radio
                    color="#25848C"
                    :ripple="false"
                    v-for="modalidade in modalidades"
                    :key="key(modalidade)"
                    :label="modalidade.descricaomodalidadeetapa"
                    :value="modalidade"
                  />
                </v-radio-group>
                <p v-if="!modalidades.length">
                  Nenhuma modalidade encontrada
                </p>

                <v-btn
                  :disabled="!choices.modalidade"
                  color="primary"
                  @click="step = 2"
                >Continuar</v-btn>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-radio-group v-if="niveis.length" v-model="choices.nivelorganizacaoetapa">
                  <v-radio
                    color="#25848C"
                    :ripple="false"
                    v-for="nivel in niveis"
                    :key="key(nivel)"
                    :label="nivel.descricaoniveletapa"
                    :value="nivel"
                  />
                </v-radio-group>

                <p v-if="!niveis.length">
                  Nenhum nível encontrado
                </p>

                <v-btn
                  :disabled="!choices.nivelorganizacaoetapa"
                  color="primary"
                  @click="step = 3"
                >Continuar</v-btn>

                <v-btn @click="back('nivelorganizacaoetapa')">Voltar</v-btn>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-radio-group v-if="fases.length" v-model="choices.faseetapa">
                  <v-radio
                    color="#25848C"
                    :ripple="false"
                    v-for="fase in fases"
                    :key="key(fase)"
                    :label="fase.descricaofaseetapa"
                    :value="fase"
                  />
                </v-radio-group>

                <p v-if="!fases.length">
                  Nenhuma fase encontrada
                </p>

                <v-btn
                  :disabled="!choices.faseetapa"
                  color="primary"
                  @click="step = 4"
                >Continuar</v-btn>

                <v-btn @click="back('faseetapa')">Voltar</v-btn>
              </v-stepper-content>
              <v-stepper-content step="4">
                <v-radio-group v-if="etapas.length" v-model="choices.etapa">
                  <v-radio
                    color="#25848C"
                    :ripple="false"
                    v-for="etapa in etapas"
                    :key="key(etapa)"
                    :value="etapa"
                  >
                    <span slot="label">
                      {{etapa.descricaoetapaescolar}} <span class="caption">({{etapa.codigoetapaescolar}})</span>
                    </span>
                  </v-radio>
                </v-radio-group>

                <p v-if="!etapas.length">
                  Nenhuma etapa encontrada
                </p>
                <v-btn color="success" :disabled="!choices.etapa" @click="confirm">Confirmar</v-btn>
                <v-btn @click="back('etapa')">Voltar</v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" @click="cancel">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import api from '@/api';

const defaultstate = () => ({
  options: {
    modalidadeetapa: [],
    nivelorganizacaoetapa: [],
    faseetapa: [],
    etapaescolar: [],
  },
  choices: {
    modalidade: null,
    nivelorganizacaoetapa: null,
    faseetapa: null,
    etapa: null,
  },
  step: 1,
  dialog: false,
});

export default {
  async created() {
    this.getAll();
  },
  data() {
    return defaultstate();
  },
  methods: {
    async open() {
      Object.assign(this.$data, defaultstate());
      await this.getAll();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      this.$emit('chosen', this.choices.etapa);
      this.close();
    },
    cancel() {
      this.close();
    },
    back(choice) {
      this.step--;
      this.choices[choice] = null;
    },
    async get(resource) {
      const { data } = await api.get(`gerencial/${resource}`);
      return data.results;
    },
    async getAll() {
      this.options.modalidadeetapa = await this.get('modalidadeetapa');
      this.options.nivelorganizacaoetapa = await this.get('nivelorganizacaoetapa');
      this.options.faseetapa = await this.get('faseetapa');
      this.options.etapaescolar = await this.get('etapaescolar');
    },
    key(k){
      return JSON.stringify(k);
    }
  },
  computed: {
    modalidades() {
      return this.options.modalidadeetapa;
    },
    niveis() {
      const mod = this.choices.modalidade;
      if (!mod) return [];
      return this.options.nivelorganizacaoetapa.filter(nivel => (
        nivel.identificadormodalidadeetapa === mod.identificadormodalidadeetapa
      ));
    },
    fases() {
      const org = this.choices.nivelorganizacaoetapa;
      if(!org) return [];
      return this.options.faseetapa.filter(fase => (
        fase.identificadormodalidadeetapa === org.identificadormodalidadeetapa &&
        fase.identificadorniveletapa === org.identificadorniveletapa
      ));
    },
    etapas() {
      const fase = this.choices.faseetapa;
      if(!fase) return [];
      return this.options.etapaescolar.filter(etapa => (
        etapa.identificadormodalidadeetapa === fase.identificadormodalidadeetapa &&
        etapa.identificadorniveletapa === fase.identificadorniveletapa &&
        etapa.identificadorfaseetapa === fase.identificadorfaseetapa
      ));
    },
  },
};
</script>

<style>
</style>
